import { useMemo } from 'react'
import { useAppParamsContext } from '../../../context/AppParamsContext'
import { parseFromLocalStorage } from '../../../helper/localStorage'
import BasePartner from './BasePartner'
import ViettelMoneyPartner from './ViettelMoneyPartner'
import BIDVPartner from './BIDVPartner'

export function getPartnerStrategy(partnerName) {
  if (partnerName === 'BIDV') {
    return new BIDVPartner()
  }

  if (parseFromLocalStorage(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
    return new ViettelMoneyPartner()
  }

  return new BasePartner()
}

export function usePartnerStrategy() {
  const { partnerName } = useAppParamsContext()
  
  // Cache lại strategy object để không bị re-create liên tục
  return useMemo(() => getPartnerStrategy(partnerName), [partnerName])
}
